// Состояние сети: navigator.onLine + принудительный офлайн (переключатель dev-панели).
const listeners = new Set<() => void>()
let forcedOffline = false
let bound = false

function emit(): void {
  for (const cb of listeners) cb()
}

function bind(): void {
  if (bound || typeof window === 'undefined') return
  bound = true
  window.addEventListener('online', emit)
  window.addEventListener('offline', emit)
}

export function isOnline(): boolean {
  if (forcedOffline) return false
  return typeof navigator === 'undefined' ? true : navigator.onLine !== false
}

export function subscribeOnline(cb: () => void): () => void {
  bind()
  listeners.add(cb)
  return () => {
    listeners.delete(cb)
  }
}

/** Имитация офлайна (dev-панель «Нет связи»): очередь копится, flush не идёт. */
export function setForcedOffline(on: boolean): void {
  if (forcedOffline === on) return
  forcedOffline = on
  emit()
}

export function isForcedOffline(): boolean {
  return forcedOffline
}
